 import React from 'react'
import styled from 'styled-components'
import { Modal, Button } from 'advenio-components'
import PropTypes from 'prop-types'

const Container = styled.div`
  padding:24px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  & > div:first-of-type {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    div{
      margin: 8px 0 8px 0;
      text-align: justify;
      padding-right: 8px;
    }
  }
`

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  margin: 16px 0 8px 0;
  flex-direction: row;
`

const WarningModal = props => (
  <Modal
    isOpened={props.open}
    onClose={props.onClose}
    headerTitle={props.type === 'disenroll' ? 'Actividad en progreso' : 'Confirmar Reinscripción'}
    statePath="classrooms"
    actionType="sendRequest"
    typePrefix="CLASSROOMS"
  >
    <Container>
      <div>
        <div>
          { props.type === 'disenroll' ? <p>
            El alumno cuenta con una actividad en progreso,
            para darlo de baja, necesita terminar la actividad pendiente y volver a intentarlo
          </p> : <p>
            ¿Estás seguro que deseas reinscribir al alumno?
          </p>}
        </div>
      </div>
      <ButtonContainer>
        <Button small onClick={props.onClose}>Cancelar</Button>
        {props.type === 'disenroll' ?
          <Button
            small
            primary
            onClick={props.disenroll}
            loading={props.loading}
          >
            Terminar Actividad
          </Button>
          : <Button
            small
            primary
            onClick={props.enroll}
            loading={props.loading}
          >
            Dar de alta
          </Button>
        }
      </ButtonContainer>
    </Container>
  </Modal>
)

WarningModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  disenroll: PropTypes.func.isRequired,
  enroll: PropTypes.func.isRequired,
}

export default WarningModal



// WEBPACK FOOTER //
// ./src/Containers/StudentProfile/ActivityInProgressWarning.jsx